import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const AffectationsDepartementPage = ({ user }) => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [departements, setDepartements] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [formData, setFormData] = useState({
    user_id: '',
    departement_id: '',
    observation: ''
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user?.role !== 'admin') return;

    loadData();
    axios.get('/users').then(res => setUsers(res.data));
    axios.get('/departements').then(res => setDepartements(res.data));
  }, [user]);

  const loadData = () => {
    axios.get('/user_departements').then(res => {
      setData(res.data);
    });
      };

  const handleSave = async () => {
    try {
      if (selected) {
        await axios.put(`/user_departements/${selected.id}`, formData);
      } else {
        await axios.post('/user_departements', formData);
      }
      loadData();
      setShowModal(false);
      setSelected(null);
    } catch (err) {
      setError("Erreur lors de l'enregistrement.");
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`/user_departements/${selected.id}`);
      loadData();
      setShowDeleteModal(false);
      setSelected(null);
    } catch {
      setError("Erreur lors de la suppression.");
    }
  };

  const columns = [
    {
      dataField: 'id',
      text: '🆔 ID',
      sort: true,
      headerStyle: { minWidth: '60px', textAlign: 'center' }
    },
    { dataField: 'user_name', text: '👤 Utilisateur', sort: true, filter: textFilter() },
    { dataField: 'departement_name', text: '🏢 Département', sort: true, filter: textFilter() },
    {
      dataField: 'actions',
      text: '⚙️ Actions',
      formatter: (_, row) => (
        <>
          <Button size="sm" variant="warning" onClick={() => openEdit(row)}><FaEdit /></Button>{' '}
          <Button size="sm" variant="danger" onClick={() => openDelete(row)}><FaTrash /></Button>
        </>
      )
    }
  ];

  const openEdit = (row) => {
    setSelected(row);
    setFormData({
      user_id: row.user_id,
      departement_id: row.departement_id,
      observation: row.observation || ''
    });
    setShowModal(true);
  };

  const openDelete = (row) => {
    setSelected(row);
    setShowDeleteModal(true);
  };

  if (user?.role !== 'admin') {
    return <Alert variant="danger" className="m-3">⛔ Accès réservé à l'administrateur</Alert>;
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-4">🔗 Gestion des accès utilisateurs aux départements</h3>

      <Button variant="success" onClick={() => {
        setSelected(null);
        setFormData({ user_id: '', departement_id: '', observation: '' });
        setShowModal(true);
      }}>
        <FaPlus /> Ajouter une affectation
      </Button>

      <BootstrapTable
        keyField="id"
        data={data}
        columns={columns}
        pagination={paginationFactory()}
        filter={filterFactory()}
        bootstrap4
        striped
        hover
        condensed
        className="mt-3"
      />

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selected ? '✏️ Modifier' : '➕ Nouvelle'} Affectation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Utilisateur</Form.Label>
            <Form.Select value={formData.user_id} onChange={(e) => setFormData({ ...formData, user_id: e.target.value })}>
              <option value="">-- Choisir --</option>
              {users.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Département</Form.Label>
            <Form.Select value={formData.departement_id} onChange={(e) => setFormData({ ...formData, departement_id: e.target.value })}>
              <option value="">-- Choisir --</option>
              {departements.map(d => (
                <option key={d.id} value={d.id}>{d.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Observation</Form.Label>
            <Form.Control as="textarea" value={formData.observation} onChange={(e) => setFormData({ ...formData, observation: e.target.value })} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleSave}>{selected ? 'Enregistrer' : 'Ajouter'}</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>❌ Supprimer l’affectation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr de vouloir supprimer cette affectation ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Annuler</Button>
          <Button variant="danger" onClick={handleDelete}>Supprimer</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AffectationsDepartementPage;
